import React from 'react';
import './App.css';
import Main from './components/main';

const App = () => {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
